import api from 'store/api';
import { setErrorCatch } from 'store/status/actions';
import {
  BudgetGroup,
  BudgetGroupPostMutation,
  BudgetGroupsFilters,
  BudgetGroupsResponse,
} from './interfaces';

export const budgetGroupsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBudgetGroups: builder.query<BudgetGroup[], Partial<BudgetGroupsFilters>>(
      {
        query: (filters) => ({
          url: 'budget-groups',
          params: filters,
        }),
        providesTags: ['BudgetGroups'],
        transformResponse: (response: BudgetGroupsResponse) =>
          response['hydra:member'].sort((budgetGroup, comparedBudgetGroup) =>
            budgetGroup.name.localeCompare(comparedBudgetGroup.name),
          ),
      },
    ),
    addBudgetGroup: builder.mutation<BudgetGroup, BudgetGroupPostMutation>({
      query: (body) => ({
        url: 'budget-groups',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BudgetGroups'],
    }),
    deleteBudgetGroup: builder.mutation({
      query: (id) => ({
        url: `/budget-groups/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const budgetCache = api.util.selectInvalidatedBy(getState(), [
            { type: 'BudgetGroups' },
          ]);
          budgetCache
            .filter(({ endpointName }) => endpointName === 'getBudgetGroups')
            .forEach(({ originalArgs }) => {
              dispatch(
                budgetGroupsApi.util.updateQueryData(
                  'getBudgetGroups',
                  originalArgs,
                  (draft) => ([
                    ...draft.filter(
                      (item) => item.id !== id,
                    ),
                  ]),
                ),
              );
            });
        } catch (error) {
          setErrorCatch(error);
        }
      },
    }),

  }),
});

export const { useGetBudgetGroupsQuery, useAddBudgetGroupMutation, useDeleteBudgetGroupMutation } =
  budgetGroupsApi;
